import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AccountSandbox } from 'src/core/account/account.sandbox';
import { CortizoUserModel } from 'src/core/account/models/user.model';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-role-dialog',
  templateUrl: './role-dialog.component.html',
  styleUrls: ['./role-dialog.component.scss']
})
export class RoleDialogComponent implements OnInit, OnDestroy {
  private subs: Subscription[] = [];
  form: FormGroup;
  initialRoles: string[] = [];

  constructor(
    public accountSandbox: AccountSandbox,
    public dialogRef: MatDialogRef<RoleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CortizoUserModel,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.accountSandbox.clearUpdateUserRoleState();
    this.initialRoles = Array.isArray(this.data.roles) ? this.data.roles.map(role => role.value) : [];
    this.form = this.fb.group({
      name: new FormControl({ value: this.data.name, disabled: true }),
      is_admin: new FormControl(this.initialRoles.includes('admin')),
      is_cook: new FormControl(this.initialRoles.includes('cook'))
    });

    this.subs.push(this.accountSandbox.updateUserRoleData$.subscribe(res => {
      if (res) {
        this.dialogRef.close(true);
      }
    }));

    this.subs.push(this.accountSandbox.updateUserRoleFailData$.subscribe(res => {
      if (res) {
        console.error('User role update failed:', res);
      }
    }));
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  submit(): void {
    const newRoles: string[] = [];
    if (this.form.value.is_admin) {
      newRoles.push('admin');
    }
    if (this.form.value.is_cook) {
      newRoles.push('cook');
    }

    // Find added and removed roles
    const addedRoles = newRoles.filter(role => !this.initialRoles.includes(role));
    const removedRoles = this.initialRoles.filter(role => !newRoles.includes(role));

    // Update and remove roles
    addedRoles.forEach(role => {
      const params = { value: role, userId: this.data.id };
      this.accountSandbox.updateUserRole(params);
    });

    removedRoles.forEach(role => {
      const params = { value: role, userId: this.data.id };
      this.accountSandbox.removeUserRole(params);
    });

    // If no roles were added or removed, close the dialog
    if (addedRoles.length === 0 && removedRoles.length === 0) {
      this.dialogRef.close();
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }
}
